import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { deleteEncaissementLine } from '../../../flux/actions/encaissementlineActions';
import { IVEncaissementTable, ITarget } from '../../../types/interfaces';

import TableContainer from "../../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faMoneyCheck } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { constants } from '../../../types/constants';

const VEncaissementTable = ({ 
  deleteEncaissementLine,
  encaissementlinesData
 }: IVEncaissementTable) => {
  const [modal, setModal] = useState(false);
  const [modalEncaissement, setModalEncaissement] = useState<any>('');
  
  const handleToggle = () => setModal(!modal);

  const modalClosedHandle = () => {
    setModalEncaissement('');
  };
  
  React.useEffect(() => console.log("modalEncaissement", modalEncaissement), [modalEncaissement])

  const columns = [
      {
        Header: "Tiré par",
        accessor: "TIRE_PAR",
        disableFilters: true
      },
      {
        Header: "Au profit de",
        accessor: "PROFIT_DE",
        disableFilters: true,
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Mode de règlement",
        accessor: "MODE_REGL",
        disableFilters: true
      },
      {
        Header: "Type échéance",
        accessor: "TYPE_ECHEANCE",
        disableFilters: true
      },
      {
        Header: "Réf. Règlement",
        accessor: "REF_REGLEMENT",
        disableFilters: true
      },
      {
        Header: "Banque",
        accessor: "BANQUE",
        disableFilters: true,
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Date Encaissement",
        accessor: "DATE_REGLEMENT",
        disableFilters: true,
        customExportDisplay: `$.DATE_REGLEMENT ? new Date($.DATE_REGLEMENT) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
      },
      {
        Header: "Date de CHQ/VAL",
        accessor: "DATE_PORTEFEUILLE",
        disableFilters: true,
        // sortType: (a, b, id, desc) => a.original[id]
        customExportDisplay: `$.DATE_PORTEFEUILLE ? new Date($.DATE_PORTEFEUILLE) : "-"`,
        Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
      },
      {
        Header: "Montant encaissé",
        accessor: "PART",
        disableFilters: true,
        sortType: (a, b, id, desc) => ((a.original[id] !== null && a.original[id] !== undefined && a.original[id] != "") ? Number(a.original[id]) : 0)
                                    > ((b.original[id] !== null && b.original[id] !== undefined && b.original[id] != "") ? Number(b.original[id]) : 0) ? 1 : -1,
        Cell: ({ value, row: {original} }) => original.PART === original.MONTANT ? ((original.PART !== null && original.PART !== undefined && original.PART != "") ? (original.PART.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-") : (<div><div style={{display: "inline-block", whiteSpace: "nowrap"}}>{(original.PART !== null && original.PART !== undefined && original.PART != "") ? (original.PART.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}&nbsp;</div><div style={{display: "inline-block", whiteSpace: "nowrap"}}>{(original.MONTANT !== null && original.MONTANT !== undefined && original.MONTANT != "") ? ("(de " + original.MONTANT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh)") : "-"}</div></div>)
      },
      // {
      //   Header: "Observation",
      //   accessor: "OBSERVATION",
      //   disableFilters: true
      // },
      {
        Header: "Banque versement",
        accessor: "BANQUE_VERSEMENT",
        disableFilters: true,
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "À Verser",
        id: "À Verser",
        accessor: row => row.STATUT === constants.STATUT_ENC_A_NE_PAS_VERSER_NR ? "À ne pas verser" : "Oui",
        disableFilters: true,
        Cell: ({ value, row: {original} }) => <div style={original.STATUT === constants.STATUT_ENC_A_NE_PAS_VERSER_NR ? {color: "darkred"} : {}}>{value || "-"}</div>
      },
      {
        Header: "Action",
        className: "text-center",
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ row: {original} }) => (
            <Container className="actionsContainer">
                {original.recto || original.verso ? <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={() => (setModalEncaissement(original), setModal(true))}
                  title="Aperçu des Scans">
                  <FontAwesomeIcon icon={faMoneyCheck} />
                </button> : null}
                <button className="btn btn-danger btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => handleDelete(original.lineIndex)}
                  title="Supprimer">
                  <FontAwesomeIcon icon={faTrash} />
                </button>
            </Container>
        ),
     }
    ];

  const handleDelete = (id: number) => {
    deleteEncaissementLine(id);
  };

  return (
    <>
      <Container>
        <TableContainer columns={columns} data={encaissementlinesData} dataName="preparation_encaissements" enableCheckBox={false} hideSettings disableFilter noDataText="Ajouter des encaissements à la table" />
      </Container>
      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle} className="modal-dialog-large">
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faMoneyCheck} />&nbsp;&nbsp;Aperçu des Scans{modalEncaissement && modalEncaissement["REF_REGLEMENT"] ? (" - " + modalEncaissement["REF_REGLEMENT"]) : ""}</ModalHeader>
        <ModalBody>
          <Container className="scanPreviewContainer">
            {modalEncaissement["recto"]?.preview && <Row>
              <Col xs="12">Recto</Col>
              <Col xs="12"><img className="scanPreview" src={modalEncaissement["recto"].preview}/></Col>
            </Row>}
            {modalEncaissement["verso"]?.preview && <Row>
              <Col xs="12">Verso</Col>
              <Col xs="12"><img className="scanPreview" src={modalEncaissement["verso"].preview}/></Col>
            </Row>}
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

export default connect(null, { deleteEncaissementLine })(VEncaissementTable);
